import type {ICompany} from "@mytour/shared";
import type React from "react";
import {Modal, ModalBody} from "reactstrap";

import {useIgnoreOnboarding, useOnboardingStatus} from "@mytour/platform";
import {AccountFeatures} from "./onboarding-welcome/steps/account-features/AccountFeatures";
import {AccountFeaturesGoogleAgenda} from "./onboarding-welcome/steps/account-features/AccountFeaturesGoogleAgenda";
import {EndingAssistant} from "./onboarding-welcome/steps/ending-assistant/EndingAssistant";
import {HelpTour} from "./onboarding-welcome/steps/help-tour/HelpTour";

type Props = {company: ICompany};

export function OnboardingWelcomeModal({company}: Props) {
  const {status} = useOnboardingStatus();
  const {ignoreOnboarding} = useIgnoreOnboarding();
  if (status === "FINISHED") {
    return null;
  }
  let content: React.ReactNode;
  if (status === "FEATURES") {
    content = <AccountFeaturesGoogleAgenda company={company} />;
  } else if (status === "FEATURES2") {
    content = <AccountFeatures company={company} />;
  } else if (status === "ENDING") {
    content = <EndingAssistant />;
  } else {
    content = <HelpTour />;
  }
  return (
    <Modal isOpen={true} id="onboarding-page" autoFocus={false} toggle={handleClose}>
      <div
        style={{
          display: "grid",
          gridTemplateRows: "min-content",
        }}
      >
        <ModalBody style={{display: "flex"}}>{content}</ModalBody>
      </div>
    </Modal>
  );

  async function handleClose() {
    await ignoreOnboarding();
  }
}
